(() => {
  'use strict';

  // Extremely conservative prefetch:
  // - Only same-origin
  // - Only when Load More button is near viewport (IO)
  // - Only once per URL
  // - Does not change Load More logic (warms cache only)

  const BTN_SEL = [
    'load-more-pagination [data-load-more-button]',
    '[data-load-more-button]',
    'load-more-pagination button'
  ].join(',');

  const seen = new Set();
  let io = null;

  function getNextUrlFromButton(btn) {
    if (!btn) return null;
    // common patterns
    const ds = btn.dataset || {};
    return ds.nextUrl || ds.nexturl || btn.getAttribute('data-next-url') || null;
  }

  function isSameOrigin(url) {
    try {
      const u = new URL(url, location.href);
      return u.origin === location.origin;
    } catch (e) {
      return false;
    }
  }

  function prefetch(url) {
    if (!url) return;
    const abs = new URL(url, location.href).toString();
    if (!isSameOrigin(abs)) return;
    if (seen.has(abs)) return;
    seen.add(abs);

    // Warm browser HTTP cache (no DOM parse, no execution)
    fetch(abs, {
      method: 'GET',
      credentials: 'same-origin',
      cache: 'force-cache',
      headers: { 'Accept': 'text/html,*/*' }
    }).catch(() => {
      // ignore
    });
  }

  function observeButton(btn) {
    if (!btn) return;
    if (!('IntersectionObserver' in window)) {
      // fallback: prefetch immediately
      prefetch(getNextUrlFromButton(btn));
      return;
    }

    if (!io) {
      io = new IntersectionObserver((entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          const b = entry.target;
          prefetch(getNextUrlFromButton(b));
        }
      }, { root: null, rootMargin: '600px 0px 600px 0px', threshold: 0.01 });
    }

    io.observe(btn);
  }

  function scan() {
    const btn = document.querySelector(BTN_SEL);
    if (btn) observeButton(btn);
  }

  // Re-scan after load more changes the pagination node.
  const mo = new MutationObserver(() => scan());
  mo.observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('DOMContentLoaded', scan);
  window.addEventListener('load', scan);
})();